import React from "react";
import Aside from "./aside";
import Header from "./header";
// import Messages from "./messages";
// import AsideInfo from "./aside-info";
import Footer from "./footer";
import classNames from "classnames";
import { useLayoutContext } from "../core/context/layout-context";
import { useLocation } from "react-router-dom";

export default function Layout({ children }: React.PropsWithChildren) {
  const { asideOpen, asideWidth, handleOpenAsude, isMobile } = useLayoutContext();
  const location = useLocation();

  // overflow-x-clip (not hidden) so position: sticky keeps working in pages
  return (
    <section className="min-h-screen w-full font-inter overflow-x-clip relative bg-[#faf7ff]">
      <Aside openAside={asideOpen} />
      <Header openAside={asideOpen} setAsideOpen={() => handleOpenAsude()} />
      <main
        style={{
          paddingLeft: isMobile ? "0px" : asideOpen ? `${asideWidth}px` : "80px",
        }}
        className={classNames(
          { "xl:pr-16": location.pathname === "/conversations" },
          "transition-[padding-left] duration-200 ease-in-out min-h-screen w-full"
        )}
      >
        {children}
      </main>

      <Footer />
    </section>
  );
}
